import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Text } from 'apps/auth/components/common/Text/Text';

import { Helper, PseudoDropdown } from '../styles';

export const CurrencyPanel = (props) => {
    const currencies = props.currencies;

    const selectCurrency = (e) => {
        e.preventDefault();
        props.onSelectCurrencyClick(e, props.currencies, props.currency?.ncode || props.currency?.id, props.ccyField);
    };

    return (
        <>
            {currencies?.length > 1 ? (
                <PseudoDropdown onClick={selectCurrency}>
                    {props.isExchange && (
                        <DiskBadge src={props.getCurrencyIcon(props.currency?.code.toLowerCase())} onError={props.onError} diskSize="x-small" />
                    )}
                    {!props.isExchange && !props.isRequest && <FlagIcon size="x-small" name={props.iconName} />}
                    <Text leftSpacer>{props.currency?.code}</Text>
                    <Icon size="16px" name="chevron-down" color="secondary" leftIndent="4px" />
                </PseudoDropdown>
            ) : (
                <Helper>
                    {props.isExchange ? (
                        <DiskBadge src={props.getCurrencyIcon(props.currency?.code.toLowerCase())} onError={props.onError} diskSize="x-small" />
                    ) : (
                        <FlagIcon size="x-small" name={props.iconName} />
                    )}
                    <Text leftSpacer>{props.currency?.code}</Text>
                </Helper>
            )}
        </>
    );
};

CurrencyPanel.propTypes = {
    currencies: PropTypes.array,
    currency: PropTypes.object,
    ccyField: PropTypes.object.isRequired,
    onSelectCurrencyClick: PropTypes.func.isRequired,
    isFrom: PropTypes.bool,
};
